// src/config.js
const CONFIG = {
    ADMIN_EMAIL: "info@brainonetech.com",
    ADMIN_WHATSAPP:"+919209440305",
};

export default CONFIG;
